<script lang="ts" setup>
withDefaults(
    defineProps<{
        label: string;
        tag?: 'label' | 'dt' | 'span';
        noMargin?: boolean;
        html?: boolean;
    }>(),
    {
        tag: 'label',
        noMargin: false,
        html: false,
    }
);
</script>

<template>
    <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component -- i18n翻訳文字列のみを使用するため安全 -->
    <component :is="tag" class="field-label" :class="{ 'no-margin': noMargin }" v-if="html" v-html="label" />
    <component :is="tag" class="field-label" :class="{ 'no-margin': noMargin }" v-else>{{ label }}</component>
</template>

<style scoped>
.field-label {
    display: block;
    font-size: 11px;
    font-weight: 500;
    line-height: 1;
    color: rgb(var(--v-theme-fieldLabel));
    text-transform: uppercase;
    letter-spacing: 0.08em;
    margin-bottom: 8px;
}

.field-label.no-margin {
    margin-bottom: 0;
}

.field-label :deep(strong) {
    font-weight: 700;
}
</style>
